const isDev =
  typeof window === "undefined"
    ? !process.env.LAMBDA_TASK_ROOT // Node.js / Lambda
    : typeof window.location !== "undefined"
      ? window.location.hostname === "localhost" // Browser
      : false; // React Native — always use prod URLs

export const globalConfig = {
  isDev,
  isProd: !isDev,
};
